import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseVO } from "../base.vo";
import {
  accountIdentity,
  iamAccountIsRoot,
  identityAccountId
} from "../../schema";
import { AccountMethods } from "../../const";
import {
  AccountIdentity,
  IAMAccountIsRoot,
  IdentityAccountId
} from "../../interface";

export class IAMAccountJwtVO extends BaseVO<IAMAccountJwtVORaw> {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountJwtVO.validationSchema()
  );

  constructor(value: IAMAccountJwtVORaw) {
    super(JsonSchemaValidator.assert(IAMAccountJwtVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["id"],
      properties: {
        id: identityAccountId,
        identity: accountIdentity,
        isRoot: iamAccountIsRoot,
        method: {
          enum: [AccountMethods.IAM]
        }
      }
    };
  }
}

interface IAMAccountJwtVORaw {
  id: IdentityAccountId;
  identity: AccountIdentity;
  isRoot: IAMAccountIsRoot;
  method: typeof AccountMethods.IAM;
}
